import { IIconProps } from '~/types';

const UsdFlag = (props: IIconProps) => (
  <svg
    width={28}
    height={20}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={28} height={20} rx={2} fill="#fff" />
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={28}
      height={20}
    >
      <rect width={28} height={20} rx={2} fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 0H0v1.333h28zm0 2.667H0V4h28zM0 5.333h28v1.334H0zM28 8H0v1.333h28zM0 10.667h28V12H0zm28 2.666H0v1.334h28zM0 16h28v1.333H0zm28 2.667H0V20h28z"
        fill="#D02F44"
      />
      <path fill="#46467F" d="M0 0h12v9.333H0z" />
      <g filter="url(#b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.667 2a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0m2.667 0a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0m2 .667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334M10.667 2a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0M3.334 4a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333m3.333-.667a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0m2 .667a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333m2 .667a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0m-3.333.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334m-2-.667a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0m-3.333.667A.667.667 0 1 0 2 4a.667.667 0 0 0 0 1.334M4 6a.667.667 0 1 1-1.334 0A.667.667 0 0 1 4 6m2 .667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334M9.334 6a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0m.667 2a.667.667 0 1 0 0-1.333A.667.667 0 0 0 10 8m-2-.667a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0M4.667 8a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333m-2-.667a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0"
          fill="url(#c)"
        />
      </g>
    </g>
    <defs>
      <linearGradient id="c" x1={1.334} y1={1.333} x2={1.334} y2={8} gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#F0F0F0" />
      </linearGradient>
      <filter
        id="b"
        x={1.334}
        y={1.333}
        width={9.334}
        height={7.667}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1008_2775" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1008_2775" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default UsdFlag;
